/*
    The simpliest example:

    <button class="facebook-tracker">Přihlásit se</button>

    Custom example:

    <a class="facebook-tracker" data-facebookEventName="Login" data-facebookParams="Přihlásit se" href="/login/">Přihlásit se</a>

    Full example:

    <a class="facebook-tracker" data-facebookEventName="Login" data-facebookParams='{"link": "Přihlásit se", "page": "Hlavní stránka"}' data-facebookTrackType="track" href="/login/">Přihlásit se</a>
*/

export const initFacebookTracker = () => {
    if (!window.fbq) {
        return
    }
    for (const node of document.querySelectorAll('.facebook-tracker')) {
        node.addEventListener('click', (e) => {
            const trackType = e.target.dataset.facebooktracktype ? e.target.dataset.facebooktracktype : 'trackCustom'
            const eventName = e.target.dataset.facebookeventname ? e.target.dataset.facebookeventname : 'click'
            let params = e.target.dataset.facebookparams ? e.target.dataset.facebookparams : {}
            if (params) {
                try {
                    params = JSON.parse(params)
                } catch (error) {
                    params = { link: params }
                }
            }
            window.fbq(trackType, eventName, params)
        })
    }
}
